<template>
  <div class="app-container">
    <!--筛选组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery">
        <el-form-item>
          <el-date-picker
            v-model="listQuery.betweenTime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="listQuery.search"
            placeholder="请输入相关内容"
            clearable
            style="width: 200px;"
            class="filter-item"
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <el-table-column
        align="center"
        width="150"
        prop="id"
        label="编号"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="operator"
        label="用户名"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ip"
        label="IP地址"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        prop="api"
        label="请求接口"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="left"
        prop="event"
        label="操作类型"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        prop="create_time"
        label="操作时间"
        show-overflow-tooltip
      ></el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />
  </div>
</template>

<script>
import api from "@/api/log";
import Pagination from "@/components/Pagination"; // 分页 给予 el-pagination 的二次封装
import commonList from "@/utils/commonList";
// import mixin from '@/mixins/mixin'
export default {
  name: "LogList",
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      api,
      listQuery: {
        limit: 15
      }
    };
  },
  created() {
    this.loadData(); // 页面加载创建时加载数据
  }
};
</script>
